<style lang="scss">
  @use "../../../../../assets/css/global.scss" as *;
  @use "../../../../../assets/css/_colors.scss" as *;
  .leaderboardRankingItem {
    align-items: center;
    border-radius: 0.625rem;
    display: flex;
    overflow: hidden;
    position: relative;

    img#tale {
      height: 110%;
      left: 0;
      position: absolute;
      transform: rotate(10deg);
      z-index: 1;
    }

    .rank {
      width: 3.75rem;
      font-size: 1.5rem;
      font-weight: 400;
      padding: 1rem;
      text-align: center;
    }

    .details {
      align-items: center;
      display: flex;
      gap: 0.75rem;
      z-index: 2;

      .nameAndValue {
        display: grid;
        padding: 0.5rem;

        .name {
          font-weight: bold;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    &-lg {
      background: linear-gradient(90deg, #1195dc 0%, #2058c2 100%);
      color: white;

      .details {
        font-size: 1rem;
      }
    }

    &-md {
      height: 85%;
      border: 2px solid $blue;
      gap: 0.75rem;

      .details {
        color: $text-black;
        font-size: 0.875rem;
      }

      .rank {
        background-color: $light-blue;
        color: $blue;
      }
    }
  }
</style>

<script>
  import Avatar from "../../../components/legacy/Avatar.svelte";

  export let size = "md"; // Sizing options: 'md' or 'lg'
  export let rank;
  export let name;
  export let value;
  export let image;
</script>

<div class="leaderboardRankingItem leaderboardRankingItem-{size}">
  {#if size === "lg"}
    <img
      id="tale"
      src="../../../../../assets/img/logo/png/tail.png"
      alt="Tale"
    />
  {/if}
  <div class="rank">{rank}</div>
  <div class="details">
    <Avatar size="lg" {image} />
    <div class="nameAndValue">
      <div class="name">{name}</div>
      <div class="value">{value}</div>
    </div>
  </div>
</div>
